/**
 * @generated SignedSource<<6af498324be23399676354540c34d0b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactSearchRefetchQuery$variables = {
  excludeConfigured?: boolean | null;
  excludeExternal?: boolean | null;
  excludeInactive?: boolean | null;
  excludeUsers?: boolean | null;
  first?: number | null;
  search?: string | null;
};
export type ContactSearchRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ContactSearch_viewer">;
  };
};
export type ContactSearchRefetchQuery = {
  response: ContactSearchRefetchQuery$data;
  variables: ContactSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeConfigured"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeExternal"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeInactive"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeUsers"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "excludeConfigured",
  "variableName": "excludeConfigured"
},
v2 = {
  "kind": "Variable",
  "name": "excludeExternal",
  "variableName": "excludeExternal"
},
v3 = {
  "kind": "Variable",
  "name": "excludeInactive",
  "variableName": "excludeInactive"
},
v4 = {
  "kind": "Variable",
  "name": "excludeUsers",
  "variableName": "excludeUsers"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ContactSearch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "foundContacts",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "ranked",
                "value": true
              },
              (v6/*: any*/)
            ],
            "concreteType": "ContactNodeConnection",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGroup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "groupSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isActive",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isConfigured",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGuest",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NoteStream",
                                "kind": "LinkedField",
                                "name": "oneOnOneWithViewer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "archived",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "96fd603d34f73e7c6e7cb4022dd25401",
    "id": null,
    "metadata": {},
    "name": "ContactSearchRefetchQuery",
    "operationKind": "query",
    "text": "query ContactSearchRefetchQuery(\n  $excludeConfigured: Boolean\n  $excludeExternal: Boolean\n  $excludeInactive: Boolean\n  $excludeUsers: Boolean\n  $first: Int\n  $search: String\n) {\n  viewer {\n    ...ContactSearch_viewer_44A039\n    id\n  }\n}\n\nfragment ContactSearch_viewer_44A039 on Viewer {\n  foundContacts: contacts(ranked: true, search: $search, first: $first, excludeConfigured: $excludeConfigured, excludeExternal: $excludeExternal, excludeInactive: $excludeInactive, excludeUsers: $excludeUsers) {\n    edges {\n      node {\n        id\n        fullName\n        email\n        image\n        isGroup\n        groupSize\n        user {\n          id\n          email\n          firstName\n          isActive\n          isConfigured\n          isGuest\n          internalAttributes {\n            oneOnOneWithViewer {\n              id\n              archived\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c9180e9e9c93c5f0d7719f23b158188";

export default node;
